import api, { ApiResponse } from './api';

export interface DashboardTip {
  /** Which producer wrote it — the deterministic sweep, or the investigating agent. */
  source: 'scanner' | 'agent';
  severity: 'critical' | 'warning' | 'info';
  title: string;
  detail: string;
  entity?: string;
  kind?: string;
  impact?: number;
  evidence?: Record<string, unknown>;
  /** Set by the agent's second pass over the scanner's tips. */
  review?: { verdict: 'confirmed' | 'refuted' | 'revised'; note: string };
}

export interface WorkspaceBriefing {
  workspace_id: string;
  workspace_name: string;
  date: string;
  tips: DashboardTip[];
  model: string | null;
  generated_at: string;
}

export const dashboardService = {
  /** Latest briefing per workspace in view; they can't be merged, so each comes back on its own. */
  getBriefings: async (pinnedWorkspaceId?: string): Promise<WorkspaceBriefing[]> => {
    const response = await api.get<ApiResponse<WorkspaceBriefing[]>>('/dashboard/briefings', {
      params: pinnedWorkspaceId ? { workspaceIds: pinnedWorkspaceId } : undefined,
    });
    return response.data.data ?? [];
  },
};
